import React from 'react';
import { Grid, IconButton, CircularProgress } from '@material-ui/core';
import EventNoteIcon from '@material-ui/icons/EventNote';

import { pqfStatusesEnum } from '../../../../utils/constants';
import { useSuspensionStatus } from '../../../../utils/effects/useSuspensionStatus';

const CellScore = ({ handleDownload, loading, status }) => {
  const isSuspended = useSuspensionStatus();

  return (
    <Grid item xs={12}>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        status === pqfStatusesEnum.Completed && (
          <IconButton onClick={isSuspended ? undefined : handleDownload} size="small" disabled={isSuspended}>
            <EventNoteIcon />
          </IconButton>
        )
      )}
    </Grid>
  );
};

export default CellScore;
